import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import { Provider } from '../ListItem/context.js';
import styles from './unordered-list.css.js';

var UnorderedList = function UnorderedList(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'disc' : _ref$type,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      columns = _ref.columns,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 4 : _ref$marginBottom,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["type", "spacing", "columns", "marginBottom", "children"]);

  return React.createElement("ul", _extends({
    className: cn(styles.UnorderedList, _defineProperty({}, styles["columns".concat(columns)], !!columns), getMarginBottomClass(marginBottom))
  }, rest), React.createElement(Provider, {
    value: {
      type: type,
      spacing: spacing,
      parentElementType: 'ul',
      columns: !!columns
    }
  }, children));
};

UnorderedList.displayName = 'UnorderedList';
UnorderedList.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.oneOf(['disc', 'circle', 'square', 'tick', 'none']),
  children: PropTypes.node,
  columns: PropTypes.oneOf([2, 3]),

  /**
   * Spacing of the `<ListItem/>`'s (0, 1, 2, 3, 4, 5, 6, 7)
   */
  spacing: PropTypes.oneOf(marginBottomLevels),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default UnorderedList;
export { UnorderedList };